// extracted by mini-css-extract-plugin
module.exports =  {"root":"VmNT8mDlKCwESeMPq6P0","chipFix":"JLBMCzfL5SFFxFZLwaJA","bigNumber":"pcrAv2fIIylwaZINZgqr"};